const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, any> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;
    const module = modules[path] as any;
    
    if (!messages[lang]) {
      messages[lang] = {};
    }
    
    // 合并翻译内容
    if (module[namespace]) {
      messages[lang][namespace] = module[namespace];
    }
  }
});

export default messages;
